import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import I18n from 'i18n-js';
import { bool, func } from 'prop-types';

import { cancelSubscription } from '@lootboy/lib/actions/SubscriptionActions';

import Alert from '~/components/Alert';
import BottomPopupButton, { SIDES } from '~/components/BottomPopupButton';

import styles from './Footer.module.scss';

export default function Footer({
  secondaryPopup,
  secondaryPopupActive,
  summaryActive,
  toggleAnimationStarted,
  toggleShow,
}) {
  const alert = useAlert();
  const dispatch = useDispatch();
  const subscriptionId = useSelector((state) => state.subscription.data?._id);

  return (
    <div className={styles.footer}>
      <div
        className={classNames(styles.wrapper, {
          [styles.mobileHidden]: !secondaryPopup,
          [styles.summaryActive]: summaryActive,
        })}
      >
        <BottomPopupButton
          className={styles.rightNextButton}
          side={SIDES.RIGHT}
          divider
          dividerClassName={styles.divider}
          onClick={() => {
            toggleShow();
            toggleAnimationStarted.setFalse();
          }}
        >
          {I18n.t('common_okay')}
        </BottomPopupButton>
      </div>
      {!secondaryPopup && (
        <div
          className={classNames(styles.wrapper, {
            [styles.summaryActive]: summaryActive,
          })}
        >
          <BottomPopupButton
            className={classNames(styles.leftButton, {
              [styles.summaryActive]: summaryActive,
              [styles.mobileHidden]: secondaryPopupActive,
            })}
            side={SIDES.LEFT}
            onClick={() => {
              dispatch(cancelSubscription(subscriptionId))
                .then(toggleAnimationStarted)
                .catch(() => {
                  toggleShow();
                  alert.error(
                    <Alert
                      body={I18n.t('season_ticket_error_cancel_failed')}
                      title={I18n.t('common_error')}
                    />,
                  );
                });
            }}
          >
            {I18n.t('season_ticket_popup_cancel_sbutton')}
          </BottomPopupButton>
          <BottomPopupButton
            className={styles.rightButton}
            side={SIDES.RIGHT}
            divider
            dividerClassName={styles.divider}
            onClick={toggleShow}
          >
            {I18n.t('season_ticket_popup_cancel_pbutton')}
          </BottomPopupButton>
        </div>
      )}
    </div>
  );
}

Footer.propTypes = {
  secondaryPopup: bool,
  secondaryPopupActive: bool,
  summaryActive: bool,
  toggleAnimationStarted: func,
  toggleShow: func.isRequired,
};
